// Project Manager → Activity Log (/pm/activity-log).
//
// The whole company's trail. There's no scope prop to pass — the endpoint reads
// the caller's role and decides what they may see, so this page and the tester's
// "My Activity" page are the same component with different words on top.

import PageHeader from "@/components/dashboard/PageHeader";
import AuditLogTable from "@/components/dashboard/AuditLogTable";

export default function PmActivity() {
  return (
    <>
      <PageHeader
        title="Activity Log"
        subtitle="Every add, change and delete across your company — who did it, to what, and when."
      />
      <AuditLogTable
        title="Company activity"
        subtitle="Projects, staffing, test cases, runs and team changes."
      />
    </>
  );
}
